module.exports = __webpack_public_path__ + "static/16-ea37f3f448c17e76621b51ce7a1ce769.png";